<template>
    <b-container fluid style="padding-left: 40px; padding-right: 40px; height: 100%;">
        <b-card>
            <b-card-body>
                <b-row align-h="center">
                    <b-col align-v="stretch" >
                        <h3>{{ $t('common.login') }}</h3>
                    </b-col>
                </b-row>
                <b-row v-if="pdfContent" style="height: 60vh;">
                    <b-col  style="height: 60vh;">
                        <PDFView
                            :src.sync="pdfContent"
                            ref="pdfView"
                            scale.sync="1"
                            :sidebarFeatureVisible="false"
                            :dropzoneFeatureVisible="false"
                        >
                        </PDFView>
<!--                        <object style="width: 100%; height: 100%;" :data="pdfContent"></object>-->
                    </b-col>
                    <b-col style="height: 60vh;" v-if="pdfLegalOwnerContent">
                        <PDFView
                            :src.sync="pdfLegalOwnerContent"
                            ref="pdfView"
                            scale.sync="1"
                            :sidebarFeatureVisible="false"
                            :dropzoneFeatureVisible="false"
                        >
                        </PDFView>
<!--                        <object style="width: 100%; height: 100%;" :data="pdfLegalOwnerContent"></object>-->
                    </b-col>
                </b-row>
<!--                <b-row>-->
<!--                    <b-col align-v="stretch">-->
<!--                        -->
<!--                    </b-col>-->
<!--                </b-row>-->
            </b-card-body>
            <b-card-footer>
                <b-button type="button" @click="register" class="btn btn-info">{{ $t('confirm-registration.button') }}</b-button>
            </b-card-footer>
        </b-card>
    </b-container>
</template>

<script>
import {PDFView} from 'vue_pdfjs_viewer';

export default {
    name: "ConfirmRegistration",
    components: {
        PDFView
    },
    data() {
        return {
            pdfContent: null,
            pdfLegalOwnerContent: null
        }
    },
    computed: {
        registrationInfo() {
            return this.$store.getters.getRegistrationInfo;
        },
        merchant() {
            return this.$store.getters.getMerchant;
        }
    },
    methods: {
        getPdf() {
            let isAuthorized = this.$store.getters.getIsAuthorized;

            if(!isAuthorized) {
                this.$store.commit('setError', this.$t('confirm-registration.denied'));
            } else {
                let query = {
                    'firstName': this.merchant.firstName,
                    'lastName': this.merchant.lastName,
                    'iban': this.registrationInfo.iban,
                    'stmtEmail': this.merchant.email,
                    'phone': this.merchant.phone,
                    'birthDate': this.merchant.birthDate,
                    'birthPlace': this.merchant.birthCity,
                    'citizenship': this.merchant.citizenship,
                    'countryOfBirth': this.merchant.birthCountry,
                    'address': this.merchant.address,
                    'city': this.merchant.city,
                    'zip': this.merchant.zip,
                    'addressTemporary': this.merchant.temporaryAddress,
                    'pio': this.merchant.pio,
                    'legalOwner': this.merchant.legalOwner,
                    'ownershipPercentage': this.merchant.ownershipPercentage,
                    'documentType': this.merchant.documentType,
                    'documentImageFront':  this.merchant.fileFront,
                    'documentImageBack':  this.merchant.fileBack,
                    'idDocumentIssuer': this.merchant.idDocumentIssuer,
                    'idDocumentDateOfIssue': this.merchant.idDocumentDateOfIssue,
                    'idDocumentExpiry': this.merchant.idDocumentExpiry,
                    'idDocumentNumber': this.merchant.idDocumentNumber
                };
                this.$store
                    .dispatch("getPdf", query)
                    .then((result) => {
                        this.pdfContent = 'data:application/pdf;base64,' + result.data.b64pdf;
                        this.pdfLegalOwnerContent = 'data:application/pdf;base64,' + result.data.loB64pdf;
                    })
                    .catch((error) => {
                        this.$store.commit("setError", error);
                    });
            }
        },
        register() {
            let query = {
                'firstName': this.merchant.firstName,
                'lastName': this.merchant.lastName,
                'iban': this.registrationInfo.iban,
                'stmtEmail': this.merchant.email,
                'phone': this.merchant.phone,
                'birthDate': this.merchant.birthDate,
                'birthPlace': this.merchant.birthCity,
                'citizenship': this.merchant.citizenship,
                'countryOfBirth': this.merchant.birthCountry,
                'address': this.merchant.address,
                'city': this.merchant.city,
                'zip': this.merchant.zip,
                'addressTemporary': this.merchant.temporaryAddress,
                'pio': this.merchant.pio,
                'legalOwner': this.merchant.legalOwner,
                'ownershipPercentage': this.merchant.ownershipPercentage,
                'documentType': this.merchant.documentType,
                'documentImageFront':  this.merchant.fileFront,
                'documentImageBack':  this.merchant.fileBack,
                'idDocumentIssuer': this.merchant.idDocumentIssuer,
                'idDocumentExpiry': this.merchant.idDocumentExpiry,
                'idDocumentDateOfIssue': this.merchant.idDocumentDateOfIssue,
                'idDocumentNumber': this.merchant.idDocumentNumber
            };
            console.log(this.merchant);
            this.$store.dispatch('registration')
                .then((response) => {
                    // go to registrationConfirmed
                    this.$router.push('/home/registrationConfirmed');
                })
                .catch(error => {
                    this.$store.commit('setError', error);
                    // TODO FIXME XXX handle different AUTH CHECK error codes!
                })
                .finally(()=>{
                });
        }
    },
    mounted() {
        this.getPdf();
    }
}
</script>

<style scoped>

</style>